"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWifiHighOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 24a2.52 2.52 0 00-2 1l2 2 2-2a2.52 2.52 0 00-2-1zM16 18a7.5 7.5 0 00-6 3l1.44 1.44a5.48 5.48 0 019.12 0L22 21a7.5 7.5 0 00-6-3z" }),
        React.createElement("path", { d: "M16 12a13.51 13.51 0 00-10.26 4.74l1.42 1.42a11.47 11.47 0 0117.68 0l1.42-1.42A13.51 13.51 0 0016 12z" }),
        React.createElement("path", { d: "M16 6a19.45 19.45 0 00-14.5 6.5l1.42 1.42a17.41 17.41 0 0126.16 0l1.42-1.42A19.45 19.45 0 0016 6z" })));
}
exports.default = SvgWifiHighOutline;
//# sourceMappingURL=WifiHighOutline.js.map